var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"AboutUs_box5_inner"}},[_c('img',{attrs:{"src":this.FImgUrl1[0],"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }